export default "__VITE_ASSET__DjTJegh4__"